import React, {Component} from 'react';
import UploaderImage from '../../../../../../common/img/uploader.svg';
import Modal from "../../../../components/Modal";

export default class Uploader extends Component {
    state = {
        isModalOpen: false,
        modalMessage: ""
    };

    handleUpload = (e) => {
        const file = e.target.files[0];
        if(file.name.split('.').pop() !== "txt") {
            this.toggleModalHandler("File's extension is not '.txt'");
        }else if(file.size > 10 * 1024 * 1024){
            this.toggleModalHandler('File is too large')
        }else{
            const reader = new FileReader();
            reader.onload = () => {
                const lines = [...new Set(reader.result.split('\n'))];
                const tenLines = this.props.user && this.props.user.apikey ? lines.join('\n') : lines.slice(0, 10).join('\n');
                this.props.setDefaultInputValue(tenLines);
                this.props.toggleTableView();
            };
            reader.readAsText(file);
        }
    };

    toggleModalHandler = (modalMessage = '') => {
        this.setState({isModalOpen:!this.state.isModalOpen, modalMessage});
    };

    render() {
        return (
            <React.Fragment>
                <div className="row tab">
                    <div className="table__uploader-wrap">
                        <img src={UploaderImage} alt=""/>
                        <div className="table__uploader-descr">
                            <h5>
                                <span>Drag a file here or</span>
                                <label htmlFor="inputFile"> <b>browse</b> </label>
                                <input type="file" id="inputFile" style={{display:'none'}} onChange={this.handleUpload}/>
                                <span>for a file to upload</span>
                            </h5>
                            <p>Make sure that you uploading a TXT file</p>
                        </div>
                    </div>
                </div>
                <Modal isShow={this.state.isModalOpen}
                       className={"popup-wrap_congratulation invalid-file-modal"}
                       openModalHandler={this.toggleModalHandler}
                       icon={true}
                       iconClass={`success-icon success-icon_warning`}
                       title={`Invalid File`}
                       description={this.state.modalMessage}/>
            </React.Fragment>
        );
    }
}
